import { render } from "./UseManualCard.vue?vue&type=template&id=673c3d72&scoped=true&ts=true"
import script from "./useManualCardHelper.ts?vue&type=script&lang=ts"
export * from "./useManualCardHelper.ts?vue&type=script&lang=ts"

import "./UseManualCard.vue?vue&type=style&index=0&id=673c3d72&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673c3d72"]])

export default __exports__